import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class ServicesService {

  constructor(private globalService: GlobalService) {}

  getAll(): Observable<any> {
    return this.globalService.get('/SP-GetAllServices/');
  }

  updateAvailableToSell(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateService/', data);
  }
}

